import numeral from 'numeral';
import { dataWithouDomain } from '../../../helpers/collectUrl';

const keys = (t) => [
    {
        renderCell: ({ item }) => {
            const url = dataWithouDomain(item.url);
            return (
                <div className="col-12 no-wrap ms-3">
                    <a
                        href={`/domains/${window.info.id}/gsc-reports/urls/url/?url=${item.url}`}
                        target="_blank"
                        rel="noreferrer"
                        title={item.url}
                    >
                        {url.length > 40 ? `${url.slice(0, 37)}...` : url}
                    </a>
                </div>
            );
        },
        key: 'url',
        label: t('search.overview.topPages.urlsList.pages'),
    },
    {
        key: 'clicks',
        label: t('search.overview.topPages.urlsList.clicks'),
        classes: 'no-wrap col',
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        key: 'rank',
        label: t('search.overview.topPages.urlsList.rank'),
        bar: true,
        renderCell: ({ item, allData }) => {
            let clicks = item.clicks / allData.reduce((e, f) => e + f.clicks, 0);
            return (clicks / 2) * 100;
        },
    },
];

export default keys;
